<div class="toaster" [ngClass]="toastType">
    <div class="toast-icon">
        <mat-icon>{{ toastIcon }}</mat-icon>
    </div>
    <div class="toast-details">
        <div>
            <div *ngIf="title" class="toast-title" [attr.aria-label]="title">
                {{ title }}
            </div>
            <div *ngIf="message && options.enableHtml" role="alert" aria-live="polite" class="toast-message" [innerHTML]="message"></div>
            <div *ngIf="message && !options.enableHtml" role="alert" aria-live="polite" class="toast-message" [attr.aria-label]="message">
                {{ message }}
            </div>
        </div>
    </div>
    <div class="close-icon">
        <a *ngIf="options.closeButton" (click)="remove()" class="toast-close-button">
            &times;
        </a>
    </div>
</div>
<div *ngIf="options.progressBar">
    <div class="toast-progress" [style.width]="width + '%'"></div>
</div>
